export const CLOUDOPS_INTAKE_URL = 'https://cloudops-intake.isolvedhcm.com';
